import { hasValue, type ILibraryMetadata, type ITagSet, planColumns, type TagKey } from './Tagging';

/** More files than this are read without tags: enough for a structure proposal, bounded in time. */
const MAX_FILES: number = 300;
const PARALLEL: number = 8;

/** Tags already on files, read from the library's tag columns (if they exist). */
export async function readTags(metadata: ILibraryMetadata, fileIds: string[]): Promise<{ [fileId: string]: ITagSet }> {
  const columns = planColumns(await metadata.getColumns());
  const present: TagKey[] = (Object.keys(columns) as TagKey[]).filter(k => columns[k].exists);
  const result: { [fileId: string]: ITagSet } = {};
  if (present.length === 0) {
    return result; // The library has never been tagged.
  }
  const queue: string[] = fileIds.slice(0, MAX_FILES);
  const worker = async (): Promise<void> => {
    for (let id = queue.shift(); id !== undefined; id = queue.shift()) {
      const fields: { [column: string]: unknown } = await metadata.getFields(id).catch(() => ({}));
      const tags: ITagSet = {};
      for (const key of present) {
        const value: unknown = fields[columns[key].column.name];
        if (hasValue(value)) {
          if (key === 'year') {
            tags.year = Number(value);
          } else {
            tags[key] = String(value);
          }
        }
      }
      if (Object.keys(tags).length > 0) {
        result[id] = tags;
      }
    }
  };
  await Promise.all(Array.from({ length: PARALLEL }, worker));
  return result;
}
